import type { SVGProps } from 'react';
const SvgAddToDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#add_to_drive_svg__a)">
      <path
        fill="currentColor"
        d="M7.71 3.52 1.15 15l3.42 5.99 6.56-11.47-3.42-6ZM13.35 15H9.73L6.3 21h8.24a5.93 5.93 0 0 1-1.19-6ZM20 16v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3Zm.71-4.75L15.42 2H8.58v.01l6.15 10.77a5.99 5.99 0 0 1 5.98-1.53Z"
      />
    </g>
    <defs>
      <clipPath id="add_to_drive_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddToDrive;
